import React, { createRef, FC, useState } from 'react';

// Shared UI Library Components
import { DiscardModal, TabsElement } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './business-information.scss';

// Components
import { AboutTab, TBusinessAboutRef } from '../about-tab/about-tab';
import { ContactDetailsTab, TContactDetailsTabRef } from '../contact-details-tab/contact-details-tab';

const defaultActiveKey = 'about';

type TTabKeys = 'about' | 'contact-details';

type TBusinessInformationProps = {};

export const BusinessInformation: FC<TBusinessInformationProps> = (
  {}: TBusinessInformationProps
) => {
  const aboutTabRef = createRef<TBusinessAboutRef>();
  const contactDetailsTabRef = createRef<TContactDetailsTabRef>();

  const [discardOpen, setDiscardOpen] = useState<boolean>(false);
  const [activeKey, setActiveKey] = useState<TTabKeys>(defaultActiveKey);
  const [nextKey, setNextKey] = useState<TTabKeys | null>(null);

  const toggleDiscardModal = (): void => {
    setDiscardOpen(!discardOpen);
  }

  const resetRefState = (): void => {
    if (activeKey === 'about') {
      aboutTabRef.current?.resetState();
      return;
    }
    if (activeKey === 'contact-details') {
      contactDetailsTabRef.current?.resetState();
      return;
    }
  }

  const onDiscardChangesHandler = (state: boolean): void => {
    if (state) {
      toggleDiscardModal();
      resetRefState();
      setActiveKey(nextKey ?? defaultActiveKey);
      setNextKey(null);
      return;
    }
    toggleDiscardModal();
  }

  const onTabClickHandler = (key: string, event: any) => {
    event.preventDefault();
    setNextKey(key as TTabKeys);

    if (aboutTabRef.current?.isHasChanges() || contactDetailsTabRef.current?.isHasChanges()) {
      toggleDiscardModal();
      return;
    }

    setActiveKey(key as TTabKeys);
  }

  return (
    <div className="business-information">

      <DiscardModal
        open={ discardOpen }
        onCancel={ onDiscardChangesHandler }
        title={ 'Are you sure you want to discard changes?' }
      />

      <div className="business-information--header">
        <div className="header-title">
          Business Information
        </div>
      </div>

      <div className="business-information--body">
        <TabsElement
          activeKey={ activeKey }
          onTabClick={ onTabClickHandler }
          items={ [
            {
              key: 'about',
              label: 'About',
              children: <AboutTab ref={ aboutTabRef }/>,
            },
            {
              key: 'contact-details',
              label: 'Contact Details',
              children: <ContactDetailsTab ref={ contactDetailsTabRef }/>,
            },
          ] }/>
      </div>
    </div>
  );
}
